module.exports = __webpack_public_path__ + "img/product_image.a901f131.svg";